import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { PushNotificationsProvider } from '../../providers/push-notifications/push-notifications';
import { ToolsProvider } from '../../providers/tools/tools';
import {
  NavController,
  ViewController,
  ActionSheetController,
} from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';

declare let CmKit: any;

@Component({
  selector: 'notification',
  templateUrl: 'notification.html',
})
export class NotificationComponent {
  log = debug('app:NotificationComponent');

  @Input()
  notification: any = {};
  hideNotification = false;
  takingAction = false;
  RequestFriend: boolean;

  constructor(
    public push: PushNotificationsProvider,
    public tools: ToolsProvider,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public actionSheet: ActionSheetController,
    public crudApi: CrudApiProvider
  ) {}

  ngOnInit() {
    if (this.notification.hide) {
      this.hideNotification = true;
    }
    if (this.notification.type === 'RECIEVED_FRIEND_REQUEST') {
      this.RequestFriend = true;
    } else {
      this.RequestFriend = false;
    }
  }

  ngOnChanges() {
    this.push.markViewed(this.notification);
  }

  openNotification(notification) {
    setTimeout(() => {
      if (!this.takingAction) {
        this.tools.openNotification(notification, this.navCtrl);
        this.tools.logAnalyticsEvent(
          'trackCustom',
          'open-notification-internal'
        );
      }
    }, 50);
  }

  notificationActions() {
    this.takingAction = true;

    this.log(
      'notificationActions() | action on notification:',
      this.notification
    );

    CmKit.ActionSheet({
      props: {
        title: '',
        buttons: [
          {
            text: 'Open',
            handler: () => {
              this.takingAction = false;
              this.openNotification(this.notification);
            },
          },
          {
            textColor: 'Accent / Danger',
            text: 'Delete',
            handler: () => {
              this.log('Delete clicked');
              this.notification.hide = true;
              this.hideNotification = true;

              this.crudApi
                .delete(`/api/notifications/${_.get(this.notification, '_id')}`)
                .then(res => {
                  this.log('notificationActions() | notification updated', res);
                })
                .catch(e => {
                  this.log('notificationActions() | Error in update', e);
                });
            },
          },
        ],
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/notification/notification.ts